import { render, staticRenderFns } from "./totalNewQr.vue?vue&type=template&id=1b841a44"
import script from "./totalNewQr.vue?vue&type=script&lang=js"
export * from "./totalNewQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports